import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { useTranslations } from 'use-intl';

import { PageHeader } from '@/components/dashboard/page-header';
import { SelectionMatrixClient } from '@/components/selection/selection-matrix-client';
import { trpc } from '@/lib/trpc/client';

export const Route = createFileRoute('/_app/offers/$id/selection')({
  component: SelectionPage,
});

function SelectionPage(): React.ReactElement {
  const { id } = Route.useParams();
  const t = useTranslations('selection');
  const offerQuery = trpc.offer.byId.useQuery({ offerId: id });
  const title = offerQuery.data?.title ?? '';

  return (
    <div className="flex flex-col gap-6">
      <PageHeader title={`${t('matrix.title')} « ${title} »`} subtitle={t('matrix.subtitle')} />
      <SelectionMatrixClient offerId={id} />
    </div>
  );
}
